
<app-oauth-loading *ngIf="isLoading"></app-oauth-loading>

<div class="utrade-plus-theme" id="theme">
    <!-- <app-header-nudge [nudgeConfiguration]="netNudgeConfiguration" *ngIf="showNetConnectedPopup; else connectivityNudge"></app-header-nudge>
    <ng-template #connectivityNudge>
        <app-header-nudge [nudgeConfiguration]="nudgeConfiguration" *ngIf="showConnectivityPopup && !isAuthenticated && !isInactive"></app-header-nudge>
    </ng-template> -->
    <router-outlet></router-outlet>
    <!-- <app-loader></app-loader> -->
</div>